// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"c8bc0447","598":"540fbd58","703":"5549a629"}[chunkId] + ".chunk.js";
};